import { parseDecimalBR, type DecimalMode } from "@cafegestor/shared";

/**
 * Número digitado na tela ("10.000,00", "1,5" ou "1.5") → texto com ponto, para a API e para
 * contas na tela. Se não for um número, devolve o texto como veio: a validação da API explica
 * o problema ao usuário. Valores em reais usam o modo "dinheiro" (ponto em grupos de 3 = milhar).
 */
export const toDecimal = (value: string, mode: DecimalMode = "numero"): string =>
  parseDecimalBR(value, mode) ?? value.trim();
